import { render, staticRenderFns } from "./SurveyTargetContainer.vue?vue&type=template&id=181f524e"
import script from "./SurveyTargetContainer.ts?vue&type=script&lang=ts&external"
export * from "./SurveyTargetContainer.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports